const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/learn",
    exact: true,
    component: "Learn",
  },
  {
    path: "/learn/grammar",
    exact: true,
    component: "Grammar",
  },
  {
    path: "/learn/grammar/:n",
    exact: true,
    component: "GrammarChapter",
  },
  {
    path: "/learn/book/:book",
    exact: true,
    component: "Book",
  },
  {
    path: "/learn/lesson/:n",
    exact: true,
    component: "Day",
  },
  {
    path: "/quiz/lesson/:n",
    exact: true,
    component: "Quiz",
  },
  {
    path: "/test/section/:n",
    exact: true,
    component: "SectionTest",
  },
  {
    path: "/test/final",
    exact: true,
    component: "FinalTest",
  },
  {
    path: "/reviewbook",
    exact: true,
    component: "ReviewBook",
  },
  {
    path: "/dictionary",
    exact: true,
    component: "Dictionary",
  },
  {
    path: "/books",
    exact: true,
    component: "Books",
  },
  {
    path: "/attributions",
    exact: true,
    component: "Attributions",
  },
  {
    path: "/about",
    exact: true,
    component: "About",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
];

export default routes;
